// Script semplice e diretto per enforcing del limite varianti
(function() {
  'use strict';
  
  // Funzione per aggiornare i dati del carrello
  async function updateCartData() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error('Errore nel recupero del carrello:', error);
      return null;
    }
  }
  
  // Funzione per mostrare un messaggio di aggiornamento limiti temporaneo
  function showLimitUpdateMessage(limit, inCart, remaining) {
    // Rimuovi messaggi esistenti
    const existingMsg = document.querySelector('.limit-update-message');
    if (existingMsg) existingMsg.remove();
    
    // Crea il messaggio
    const message = document.createElement('div');
    message.className = 'limit-update-message';
    message.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 15px 20px;
      border-radius: 5px;
      z-index: 9999;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      animation: slideIn 0.3s ease;
    `;
    
    let msgText = '';
    if (remaining === 0) {
      msgText = window.purchaseLimitTranslations?.limitReached || `Limite di ${limit} unità raggiunto`;
    } else {
      msgText = (window.purchaseLimitTranslations?.canAddMore || 'Puoi ancora aggiungere {{ remaining }} unità')
        .replace('{{ remaining }}', remaining)
        .replace('{{ limit }}', limit);
    }
    
    message.textContent = msgText;
    document.body.appendChild(message);
    
    // Rimuovi dopo 3 secondi
    setTimeout(() => {
      message.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => message.remove(), 300);
    }, 3000);
  }
  
  // Funzione per aggiornare il messaggio di limite permanente nella pagina prodotto
  function updateProductLimitMessage(limit, inCart, remaining) {
    // Prima rimuovi eventuali messaggi purchase-limit-warning creati da purchase-limits.js
    const oldWarnings = document.querySelectorAll('.purchase-limit-warning');
    oldWarnings.forEach(warning => warning.remove());
    
    // Trova o crea il contenitore del messaggio
    let messageContainer = document.querySelector('.variant-limit-message');
    
    if (!messageContainer) {
      // Cerca il form prodotto o il selettore quantità
      const quantitySelector = document.querySelector('quantity-counter, .quantity-selector, .quantity__wrapper');
      const productForm = document.querySelector('form[action*="/cart/add"]');
      const targetElement = quantitySelector || productForm;
      
      if (!targetElement) return;
      
      // Crea il contenitore del messaggio
      messageContainer = document.createElement('div');
      messageContainer.className = 'variant-limit-message';
      messageContainer.style.cssText = `
        margin-top: 10px;
        padding: 10px;
        background: #f0f0f0;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
        display: none;
      `;
      
      // Inserisci dopo il selettore quantità se esiste, altrimenti prima del form
      if (quantitySelector) {
        quantitySelector.parentNode.insertAfter(messageContainer, quantitySelector.nextSibling);
      } else {
        targetElement.parentNode.insertAfter(messageContainer, targetElement);
      }
    }
    
    // Se non c'è limite o il limite è 999, nascondi TUTTI i messaggi di limite
    if (!limit || limit === 999) {
      messageContainer.style.display = 'none';
      messageContainer.textContent = '';
      // Rimuovi anche eventuali altri messaggi di avviso
      const allWarnings = document.querySelectorAll('.purchase-limit-warning, .limit-update-message');
      allWarnings.forEach(warning => warning.remove());
      return;
    }
    
    // Costruisci il messaggio
    let msgText = '';
    if (remaining === 0) {
      msgText = window.purchaseLimitTranslations?.limitReached || `Hai già raggiunto il limite massimo di ${limit} unità per questa variante`;
      messageContainer.style.background = '#ffebee';
      messageContainer.style.color = '#c62828';
    } else if (inCart > 0) {
      msgText = (window.purchaseLimitTranslations?.canAddMore || 'Puoi ancora aggiungere {{ remaining }} unità (limite: {{ limit }})')
      messageContainer.style.background = '#fff3e0';
      messageContainer.style.color = '#e65100';
    } else {
      msgText = (window.purchaseLimitTranslations?.maxAllowed || 'Massimo {{ limit }} unità per questa variante')
        .replace('{{ limit }}', limit);
      messageContainer.style.background = '#e3f2fd';
      messageContainer.style.color = '#1565c0';
    }
    
    // Aggiorna il messaggio
    messageContainer.textContent = msgText;
    messageContainer.style.display = 'block';
  }
  
  // Funzione per aggiornare i limiti dopo l'aggiunta al carrello
  async function updateLimitsAfterAdd() {
    const cart = await updateCartData();
    if (!cart) return;
    
    // Trova tutti gli input di quantità nella pagina prodotto
    const quantityInputs = document.querySelectorAll('input[name="quantity"][data-variant-id]:not([data-cart-limit])');
    
    quantityInputs.forEach(input => {
      const variantId = parseInt(input.dataset.variantId);
      const purchaseLimit = parseInt(input.dataset.purchaseLimit) || 999;
      
      if (purchaseLimit !== 999) {
        // Calcola quante unità di questa variante sono nel carrello
        let inCartQty = 0;
        cart.items.forEach(item => {
          if (item.variant_id === variantId) {
            inCartQty += item.quantity;
          }
        });
        
        // Aggiorna gli attributi data
        const remaining = Math.max(0, purchaseLimit - inCartQty);
        input.dataset.inCart = inCartQty;
        input.dataset.remaining = remaining;
        input.setAttribute('data-in-cart', inCartQty);
        input.setAttribute('data-remaining', remaining);
        input.setAttribute('max', remaining);
        input.max = remaining;
        
        console.log(`Aggiornato limiti per variante ${variantId}: inCart=${inCartQty}, remaining=${remaining}`);
        
        // Aggiorna il messaggio permanente nella pagina
        updateProductLimitMessage(purchaseLimit, inCartQty, remaining);
        
        // Mostra anche un messaggio temporaneo se i limiti sono stati aggiornati
        if (inCartQty > 0) {
          showLimitUpdateMessage(purchaseLimit, inCartQty, remaining);
        }
        
        // SEMPRE disabilita il form se remaining è 0 o se il valore supera remaining
        const form = input.closest('form');
        const currentValue = parseInt(input.value) || 1;
        
        if (remaining === 0 || currentValue > remaining) {
          // Disabilita TUTTO
          input.value = Math.min(remaining, 0);
          input.disabled = true;
          input.setAttribute('disabled', 'disabled');
          
          if (form) {
            // Disabilita TUTTI i pulsanti submit del form
            const allSubmitBtns = form.querySelectorAll('[type="submit"], button[name="add"], [data-add-to-cart]');
            allSubmitBtns.forEach(btn => {
              btn.disabled = true;
              btn.setAttribute('disabled', 'disabled');
              btn.style.opacity = '0.5';
              btn.style.cursor = 'not-allowed';
              
              // Cambia il testo del pulsante
              if (remaining === 0) {
                const limitText = window.purchaseLimitTranslations?.limitReachedButton || 'Limite raggiunto';
                const textEl = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('.btn__text') || btn;
                if (textEl) {
                  textEl.textContent = limitText;
                }
              }
            });
            
            // Aggiungi attributo al form stesso
            form.setAttribute('data-limit-reached', 'true');
            
            // Aggiungi input nascosto
            if (!form.querySelector('input[data-limit-reached="true"]')) {
              const limitInput = document.createElement('input');
              limitInput.type = 'hidden';
              limitInput.name = 'limit_reached';
              limitInput.value = 'true';
              limitInput.setAttribute('data-limit-reached', 'true');
              form.appendChild(limitInput);
            }
          }
          
          // Disabilita i pulsanti +/-
          const container = input.closest('.quantity-selector, .quantity__wrapper, quantity-counter');
          if (container) {
            const allBtns = container.querySelectorAll('button');
            allBtns.forEach(btn => {
              btn.disabled = true;
              btn.setAttribute('disabled', 'disabled');
            });
          }
        } else {
          // Riabilita solo se remaining > 0
          input.disabled = false;
          input.removeAttribute('disabled');
          
          // Aggiorna il valore
          if (parseInt(input.value) > remaining) {
            input.value = remaining;
          }
          
          if (form) {
            // Riabilita i pulsanti submit
            const allSubmitBtns = form.querySelectorAll('[type="submit"], button[name="add"], [data-add-to-cart]');
            allSubmitBtns.forEach(btn => {
              btn.disabled = false;
              btn.removeAttribute('disabled');
              btn.style.opacity = '';
              btn.style.cursor = '';
              
              // Ripristina il testo originale
              const textEl = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('.btn__text') || btn;
              if (textEl && textEl.textContent.includes('Limite')) {
                textEl.textContent = 'Aggiungi al carrello';
              }
            });
            
            // Rimuovi attributo dal form
            form.removeAttribute('data-limit-reached');
            
            // Rimuovi input nascosto
            const limitInput = form.querySelector('input[data-limit-reached="true"]');
            if (limitInput) limitInput.remove();
          }
        }
        
        // Applica i limiti immediatamente
        enforceVariantLimits();
      }
    });
  }
  
  // Funzione principale che controlla e applica i limiti
  function enforceVariantLimits() {
    // Selettore più ampio per catturare tutti gli input quantità
    const quantityInputs = document.querySelectorAll('.quantity__input, input[name="quantity"], input[type="number"][name="quantity"], [data-quantity-input]');
    
    quantityInputs.forEach(input => {
      const purchaseLimit = parseInt(input.dataset.purchaseLimit) || 999;
      const isCartItem = input.dataset.cartLimit === 'true';
      
      // Per gli item del carrello, lascia che cart-purchase-limits.js gestisca tutto
      if (isCartItem) {
        return;
      }
      
      // Se ha un limite valido (non 999)
      if (purchaseLimit !== 999) {
        const remaining = parseInt(input.dataset.remaining) || 0;
        const currentValue = parseInt(input.value) || 1;
        
        console.log(`Limite enforcer: Limite=${purchaseLimit}, Remaining=${remaining}, Value=${currentValue}`);
        
        // Forza il max attribute
        input.max = remaining;
        input.setAttribute('max', remaining);
        
        const form = input.closest('form');
        
        // DISABILITA TUTTO se remaining è 0 o value > remaining
        if (remaining === 0 || currentValue > remaining) {
          // Correggi il valore
          input.value = Math.min(remaining, currentValue);
          
          if (remaining === 0) {
            input.value = 0;
            input.disabled = true;
            input.setAttribute('disabled', 'disabled');
          }
          
          // DISABILITA TUTTI I PULSANTI SUBMIT
          if (form) {
            const allSubmitBtns = form.querySelectorAll('[type="submit"], button[name="add"], [data-add-to-cart], .btn--add-to-cart');
            allSubmitBtns.forEach(btn => {
              btn.disabled = true;
              btn.setAttribute('disabled', 'disabled');
              btn.style.pointerEvents = 'none';
              btn.style.opacity = '0.5';
              
              if (remaining === 0) {
                const limitText = window.purchaseLimitTranslations?.limitReachedButton || 'Limite raggiunto';
                const textEl = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('.btn__text') || btn;
                if (textEl && !textEl.textContent.includes('Limite')) {
                  btn.setAttribute('data-original-text', textEl.textContent);
                  textEl.textContent = limitText;
                }
              }
            });
            
            form.setAttribute('data-limit-reached', 'true');
          }
          
          // Disabilita i pulsanti +/-
          const container = input.closest('.quantity-selector, .quantity__wrapper, quantity-counter');
          if (container && remaining === 0) {
            container.querySelectorAll('button').forEach(btn => {
              btn.disabled = true;
              btn.setAttribute('disabled', 'disabled');
            });
          }
        } else {
          // Riabilita solo se remaining > 0 E value <= remaining
          if (currentValue <= remaining) {
            input.disabled = false;
            input.removeAttribute('disabled');
            
            if (form) {
              form.removeAttribute('data-limit-reached');
              
              // Riabilita i pulsanti submit
              const allSubmitBtns = form.querySelectorAll('[type="submit"], button[name="add"], [data-add-to-cart], .btn--add-to-cart');
              allSubmitBtns.forEach(btn => {
                btn.disabled = false;
                btn.removeAttribute('disabled');
                btn.style.pointerEvents = '';
                btn.style.opacity = '';
                
                // Ripristina il testo originale
                const originalText = btn.getAttribute('data-original-text');
                if (originalText) {
                  const textEl = btn.querySelector('[data-add-to-cart-text]') || btn.querySelector('.btn__text') || btn;
                  if (textEl) {
                    textEl.textContent = originalText;
                  }
                }
              });
            }
          }
        }
      }
    });
  }
  
  // Intercetta ogni tentativo di modifica
  function interceptQuantityChanges() {
    document.addEventListener('input', function(e) {
      if (e.target.matches('.quantity__input, input[name="quantity"]')) {
        const input = e.target;
        // Ignora gli item del carrello
        if (input.dataset.cartLimit === 'true') {
          return;
        }
        // Controlla SOLO se ha l'attributo data-remaining (pagine prodotto)
        if (input.dataset.remaining !== undefined && input.dataset.remaining !== null && input.dataset.remaining !== '') {
          const max = parseInt(input.getAttribute('max'));
          const value = parseInt(input.value);
          
          if (max && value > max) {
            input.value = max;
            console.log(`Limite enforcer: Valore corretto da ${value} a ${max}`);
          }
        }
      }
    });
    
    // Intercetta click sui pulsanti
    document.addEventListener('click', function(e) {
      if (e.target.closest('.quantity__plus, .quantity__minus')) {
        setTimeout(enforceVariantLimits, 10);
      }
    });
  }
  
  // Intercetta il submit del form
  function interceptFormSubmit() {
    document.addEventListener('submit', async function(e) {
      const form = e.target;
      if (form.querySelector('[name="add"]') || (form.action?.includes('/cart/add') && !form.action?.includes('/cart/update'))) {
        const quantityInput = form.querySelector('input[name="quantity"]');
        
        // Ignora i form del carrello
        if (quantityInput && quantityInput.dataset.cartLimit === 'true') {
          return;
        }
        
        // Controlla se il form ha il limite raggiunto
        const limitReachedInput = form.querySelector('input[data-limit-reached="true"]');
        if (limitReachedInput) {
          e.preventDefault();
          e.stopPropagation();
          alert(window.purchaseLimitTranslations?.limitReached || 'Hai già raggiunto il limite massimo per questa variante');
          return false;
        }
        
        // Controlla SOLO se ha l'attributo data-remaining (pagine prodotto)
        if (quantityInput) {
          // Prendi sempre i valori più aggiornati
          const purchaseLimit = parseInt(quantityInput.dataset.purchaseLimit) || 999;
          const remaining = quantityInput.dataset.remaining !== undefined ? parseInt(quantityInput.dataset.remaining) : purchaseLimit;
          const value = parseInt(quantityInput.value) || 1;
          const inCart = parseInt(quantityInput.dataset.inCart) || 0;
          
          console.log(`Submit check enforcer: value=${value}, limit=${purchaseLimit}, inCart=${inCart}, remaining=${remaining}`);
          
          // Se abbiamo un limite valido (non 999) e il valore supera il remaining
          if (purchaseLimit !== 999) {
            if (remaining === 0 || value === 0) {
              e.preventDefault();
              e.stopPropagation();
              alert(window.purchaseLimitTranslations?.limitReached || 'Hai già raggiunto il limite massimo per questa variante');
              return false;
            }
            
            if (value > remaining) {
              e.preventDefault();
              e.stopPropagation();
              const msg = window.purchaseLimitTranslations?.canOnlyAdd || 'Puoi aggiungere solo {{ remaining }} unità';
              alert(msg.replace('{{ remaining }}', remaining).replace('{{ limit }}', purchaseLimit));
              // Correggi il valore
              quantityInput.value = remaining;
              return false;
            }
            
            // Se il submit è valido, aspetta un attimo e poi aggiorna i limiti
            setTimeout(async () => {
              await updateLimitsAfterAdd();
            }, 1500); // Aspetta che il carrello si aggiorni
          }
        }
      }
    });
  }
  
  // Variabile per prevenire aggiornamenti multipli
  let isUpdating = false;
  
  // Funzione per aggiornare i limiti per una specifica variante
  async function updateVariantLimits(variantId) {
    // Previeni aggiornamenti multipli simultanei
    if (isUpdating) {
      console.log('Aggiornamento già in corso, skip');
      return;
    }
    
    isUpdating = true;
    console.log('=== Aggiornamento per variante:', variantId);
    
    // Rimuovi eventuali vecchi messaggi di avviso all'inizio
    const oldWarnings = document.querySelectorAll('.purchase-limit-warning');
    oldWarnings.forEach(warning => warning.remove());
    
    try {
      // 1. Ottieni i limiti e disponibilità dal DOM
      const limitsElement = document.querySelector('[data-variant-purchase-limits]');
      const availabilityElement = document.querySelector('[data-variant-availability]');
      let purchaseLimit = 999;
      let isAvailable = true;
      
      if (limitsElement) {
        try {
          const limitsData = JSON.parse(limitsElement.textContent || '[]');
          const limitItem = limitsData.find(item => item.variant_id == variantId);
          if (limitItem) {
            purchaseLimit = parseInt(limitItem.limit);
          }
        } catch (e) {
          console.error('Errore parsing limiti:', e);
        }
      }
      
      // Controlla la disponibilità della variante
      if (availabilityElement) {
        try {
          const availabilityData = JSON.parse(availabilityElement.textContent || '[]');
          const variantData = availabilityData.find(item => item.variant_id == variantId);
          if (variantData) {
            isAvailable = variantData.available;
          }
        } catch (e) {
          console.error('Errore parsing disponibilità:', e);
        }
      }
      
      console.log(`Variante ${variantId}: Limite = ${purchaseLimit}, Disponibile = ${isAvailable}`);
      
      // 2. Trova l'input quantità
      const input = document.querySelector('form[action*="/cart/add"] input[name="quantity"]:not([data-cart-limit])');
      if (!input) {
        console.log('Input non trovato');
        return;
      }
      
      // 3. Aggiorna attributi base
      input.setAttribute('data-variant-id', variantId);
      input.setAttribute('data-purchase-limit', purchaseLimit);
      
      // 4. Recupera i dati del carrello
      const cart = await updateCartData();
      if (!cart) {
        console.error('Impossibile recuperare dati carrello');
        return;
      }
    
    if (purchaseLimit !== 999) {
      // VARIANTE CON LIMITE
      console.log('--- VARIANTE CON LIMITE ---');
      
      // Calcola quante unità di questa variante sono nel carrello
      let inCartQty = 0;
      cart.items.forEach(item => {
        if (item.variant_id === parseInt(variantId) || item.variant_id === variantId.toString()) {
          inCartQty += item.quantity;
          console.log(`Trovato nel carrello: ${item.title}, Qty: ${item.quantity}`);
        }
      });
      
      // Calcola il remaining
      const remaining = Math.max(0, purchaseLimit - inCartQty);
      
      // Aggiorna TUTTI gli attributi
      input.dataset.inCart = inCartQty;
      input.dataset.remaining = remaining;
      input.setAttribute('data-in-cart', inCartQty);
      input.setAttribute('data-remaining', remaining);
      input.setAttribute('max', remaining);
      input.max = remaining;
      
      console.log(`RIEPILOGO: Limite=${purchaseLimit}, Nel carrello=${inCartQty}, Rimanenti=${remaining}`);
      
      // Aggiorna il messaggio di limite nella pagina
      updateProductLimitMessage(purchaseLimit, inCartQty, remaining);
      
      // Trova il form
      const form = input.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) {
        console.error('Form non trovato');
        return;
      }
      
      // Funzione helper SEMPLIFICATA per aggiornare i pulsanti
      function updateButtons(disabled, buttonText) {
        // Trova SOLO il pulsante principale add to cart
        const addBtn = form.querySelector('[type="submit"][name="add"], [data-add-to-cart]');
        if (!addBtn) return;
        
        console.log(`Aggiorno pulsante: disabled=${disabled}, text=${buttonText}`);
        
        // Aggiorna stato disabled
        addBtn.disabled = disabled;
        
        if (disabled) {
          addBtn.style.opacity = '0.5';
          addBtn.style.cursor = 'not-allowed';
        } else {
          addBtn.style.opacity = '';
          addBtn.style.cursor = '';
        }
        
        // Aggiorna il testo solo se fornito
        if (buttonText) {
          const textEl = addBtn.querySelector('[data-add-to-cart-text]') || 
                        addBtn.querySelector('.btn__text') || 
                        addBtn;
          
          // Salva il testo originale la prima volta
          if (!addBtn.dataset.originalText && textEl.textContent) {
            addBtn.dataset.originalText = textEl.textContent;
          }
          
          textEl.textContent = buttonText;
        } else if (!disabled && addBtn.dataset.originalText) {
          // Ripristina il testo originale se non disabilitato
          const textEl = addBtn.querySelector('[data-add-to-cart-text]') || 
                        addBtn.querySelector('.btn__text') || 
                        addBtn;
          textEl.textContent = addBtn.dataset.originalText;
        }
      }
      
      // Aggiorna pulsanti +/- nel quantity selector
      function updateQuantityButtons() {
        const container = input.closest('.quantity-selector, .quantity__wrapper, quantity-counter, .quantity');
        if (container) {
          const plusBtn = container.querySelector('.quantity__plus, .quantity__button.quantity__plus, button[name="increase"]');
          const minusBtn = container.querySelector('.quantity__minus, .quantity__button.quantity__minus, button[name="decrease"]');
          
          if (remaining === 0) {
            if (plusBtn) plusBtn.disabled = true;
            if (minusBtn) minusBtn.disabled = true;
          } else {
            if (plusBtn) plusBtn.disabled = parseInt(input.value) >= remaining;
            if (minusBtn) minusBtn.disabled = parseInt(input.value) <= 1;
          }
        }
      }
      
      if (remaining === 0) {
        // Disabilita tutto
        input.value = 0;
        input.disabled = true;
        input.setAttribute('disabled', 'disabled');
        
        const limitText = window.purchaseLimitTranslations?.limitReachedButton || 'Limite raggiunto';
        updateButtons(true, limitText);
        updateQuantityButtons();
        
        // Aggiungi indicatore al form
        if (form) {
          form.setAttribute('data-limit-reached', 'true');
        }
      } else {
        // Riabilita con il nuovo limite
        input.disabled = false;
        input.removeAttribute('disabled');
        input.value = Math.min(1, remaining);
        
        updateButtons(false);
        updateQuantityButtons();
        
        // Rimuovi indicatore dal form
        if (form) {
          form.removeAttribute('data-limit-reached');
        }
      }
    } else {
      // VARIANTE SENZA LIMITE
      console.log('--- VARIANTE SENZA LIMITE ---');
      
      // Reset COMPLETO di tutti gli attributi limite
      input.removeAttribute('max');
      input.removeAttribute('data-remaining');
      input.removeAttribute('data-in-cart');
      input.dataset.remaining = '';
      input.dataset.inCart = '';
      
      // Nasconde il messaggio di limite
      updateProductLimitMessage(999, 0, 999);
      
      // Trova il form
      const form = input.closest('form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      
      // Rimuovi attributi limite dal form
      form.removeAttribute('data-limit-reached');
      
      // Trova il pulsante add to cart
      const addBtn = form.querySelector('[type="submit"][name="add"], [data-add-to-cart], .add-to-c-button');
      if (!addBtn) return;
      
      console.log('Ripristino pulsante per variante senza limite, disponibile:', isAvailable);
      
      // Controlla se la variante è disponibile
      if (isAvailable) {
        // VARIANTE DISPONIBILE - abilita tutto
        input.disabled = false;
        input.removeAttribute('disabled');
        input.value = 1;
        
        // Riabilita il pulsante
        addBtn.disabled = false;
        addBtn.removeAttribute('disabled');
        addBtn.removeAttribute('aria-disabled');
        addBtn.style.opacity = '';
        addBtn.style.cursor = '';
        addBtn.style.pointerEvents = '';
        addBtn.classList.remove('disabled');
        
        // Ripristina il testo "Aggiungi al carrello"
        const textEl = addBtn.querySelector('[data-add-to-cart-text]') || 
                      addBtn.querySelector('.btn__text') || 
                      addBtn;
        
        // Forza sempre "Aggiungi al carrello" per varianti senza limite disponibili
        textEl.textContent = window.addToCartTranslation || 'Aggiungi al carrello';
        console.log('Testo impostato a:', textEl.textContent);
        
        // Riabilita i pulsanti quantity
        const container = input.closest('.quantity-selector, .quantity__wrapper, quantity-counter');
        if (container) {
          const plusBtn = container.querySelector('.quantity__plus, button[name="increase"]');
          const minusBtn = container.querySelector('.quantity__minus, button[name="decrease"]');
          if (plusBtn) plusBtn.disabled = false;
          if (minusBtn) minusBtn.disabled = parseInt(input.value) <= 1;
        }
      } else {
        // VARIANTE NON DISPONIBILE - disabilita tutto
        input.disabled = true;
        input.setAttribute('disabled', 'disabled');
        input.value = 0;
        
        // Disabilita il pulsante
        addBtn.disabled = true;
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.style.opacity = '0.5';
        addBtn.style.cursor = 'not-allowed';
        
        // Imposta il testo "Esaurito"
        const textEl = addBtn.querySelector('[data-add-to-cart-text]') || 
                      addBtn.querySelector('.btn__text') || 
                      addBtn;
        
        textEl.textContent = window.soldOutTranslation || 'Esaurito';
        console.log('Testo impostato a:', textEl.textContent);
        
        // Disabilita i pulsanti quantity
        const container = input.closest('.quantity-selector, .quantity__wrapper, quantity-counter');
        if (container) {
          container.querySelectorAll('button').forEach(btn => {
            btn.disabled = true;
            btn.setAttribute('disabled', 'disabled');
          });
        }
      }
    }
    
    // Applica i controlli
    enforceVariantLimits();
    
    } finally {
      // Rilascia il lock dopo un breve delay
      setTimeout(() => {
        isUpdating = false;
      }, 100);
    }
  }
  
  // Monitora i cambi di variante - SEMPLIFICATO
  function monitorVariantChanges() {
    console.log('Inizializzo monitoraggio cambi variante');
    
    let lastVariantId = null;
    
    // Ascolta SOLO l'evento principale variant:change
    document.addEventListener('variant:change', async function(e) {
      let variantId = null;
      
      // Prendi l'ID dalla sorgente più affidabile
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        variantId = e.detail.variant.id;
      }
      
      // Se è la stessa variante, non fare nulla
      if (variantId && variantId !== lastVariantId) {
        lastVariantId = variantId;
        console.log('Cambio a variante:', variantId);
        
        // Aspetta che il DOM si aggiorni
        setTimeout(async () => {
          await updateVariantLimits(variantId);
        }, 200);
      }
    });
    
    // Ascolta SOLO l'evento custom che triggeriamo noi
    document.addEventListener('variant:updated', async function(e) {
      if (e.detail && e.detail.variantId && e.detail.variantId !== lastVariantId) {
        lastVariantId = e.detail.variantId;
        console.log('Evento custom per variante:', e.detail.variantId);
        await updateVariantLimits(e.detail.variantId);
      }
    });
  }
  
  // Inizializza tutto
  async function init() {
    console.log('Variant Limit Enforcer: Inizializzazione');
    
    // PRIMA cosa: aggiorna i dati dal carrello
    await updateLimitsAfterAdd();
    
    // Applica i limiti immediatamente
    enforceVariantLimits();
    
    // Intercetta modifiche
    interceptQuantityChanges();
    
    // Intercetta submit
    interceptFormSubmit();
    
    // Monitora cambi variante
    monitorVariantChanges();
    
    // NON ricontrollare periodicamente - causa troppi aggiornamenti
    // setInterval(enforceVariantLimits, 500);
    
    // Forza controllo immediato su tutti gli input
    setTimeout(() => {
      enforceVariantLimits();
      // Verifica anche tutti i form
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        const input = form.querySelector('input[name="quantity"]');
        if (input) {
          const event = new Event('input', { bubbles: true });
          input.dispatchEvent(event);
        }
      });
    }, 100);
    
    // Ascolta l'evento di aggiunta al carrello di Shopify
    document.addEventListener('cart:added', async function() {
      console.log('Prodotto aggiunto al carrello, aggiorno i limiti...');
      await updateLimitsAfterAdd();
    });
    
    // Ascolta anche ajax:cart:added se il tema lo usa
    document.addEventListener('ajax:cart:added', async function() {
      console.log('Prodotto aggiunto al carrello (ajax), aggiorno i limiti...');
      await updateLimitsAfterAdd();
    });
    
    // Intercetta le chiamate fetch per /cart/add
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      
      // Se è una chiamata a /cart/add e ha successo, aggiorna i limiti
      if (args[0] && args[0].toString().includes('/cart/add') && response.ok) {
        console.log('Intercettato fetch a /cart/add, aggiorno i limiti...');
        setTimeout(async () => {
          await updateLimitsAfterAdd();
        }, 500);
      }
      
      return response;
    };
  }
  
  // Avvia quando DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();